import { render, staticRenderFns } from "./TkHotelScrollToTop.vue?vue&type=template&id=561c5645&"
import script from "./TkHotelScrollToTop.vue?vue&type=script&lang=js&"
export * from "./TkHotelScrollToTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports